import * as React from 'react';
import { DOMAIN } from '../lib/api';
import { localStorageKeys, useLocalStorageState } from './useLocalStorageState';

export const LATEST_CHANGE = {
  version: '2',
  message: (
    <span>
      Our Privacy Policy now includes compliance with the Data Privacy Framework (Swiss,
      EU-US and UK)&nbsp;&nbsp;
      <a target="_blank" rel="noreferrer" href={`${DOMAIN}/privacy_policy`}>
        Learn more...
      </a>
      .
    </span>
  )
};

export type ChangeNoticeState = {
  currentVersion: string;
  firstSeen: number;
  dismissed: boolean;
};

const isChangeNoticeState = (obj: unknown): obj is ChangeNoticeState => {
  if (
    obj &&
    typeof obj === 'object' &&
    'currentVersion' in obj &&
    'firstSeen' in obj &&
    'dismissed' in obj &&
    typeof obj.currentVersion === 'string' &&
    typeof obj.firstSeen === 'number' &&
    typeof obj.dismissed === 'boolean'
  ) {
    return true;
  } else {
    return false;
  }
};

export const useChangeNotice = () => {
  const [changeNotice, setChangeNotice] = useLocalStorageState<ChangeNoticeState>(
    localStorageKeys.changeNotice,
    {
      currentVersion: '0',
      firstSeen: Date.now(),
      dismissed: false
    },
    isChangeNoticeState
  );

  React.useEffect(() => {
    // Track the first time the user sees this version and dismiss it after one week
    if (changeNotice?.currentVersion !== LATEST_CHANGE.version) {
      setChangeNotice({
        currentVersion: LATEST_CHANGE.version,
        firstSeen: Date.now(),
        dismissed: false
      });
    } else if (Date.now() - changeNotice.firstSeen > 1000 * 60 * 60 * 24 * 7) {
      setChangeNotice(prev => ({
        ...prev,
        dismissed: true
      }));
    }
  }, [changeNotice.firstSeen, changeNotice.currentVersion, setChangeNotice]);

  return {
    changeNotice,
    setChangeNotice
  };
};
